import _ from 'lodash';

export function buildTeamsOptions({ teams }) {
	return _.map([{ id: 'all', name: 'All Teams' }, ...teams], team => ({
		id: team?.id,
		label: team.name,
	}));
}

export function buildTeamMemberOptions({ allMembersFromAllTeams, filterTeam, isUserCompanyAdminOrSupport }) {
	let users;

	if (isUserCompanyAdminOrSupport) {
		const usersToSort = filterTeam?.users || allMembersFromAllTeams;
		users = usersToSort?.filter(user => user?.Roles?.length > 0 || user?.roles?.length > 0);
		const userOpts = _.map(users, user => ({
			id: user.Id || user?.userId,
			label: `${user.FirstName || user.firstName} ${user.LastName || user.lastName}`,
		}));

		return [{ id: 'all', label: 'All Members' }, ...userOpts];
	} else {
		users = filterTeam?.users;
		const userOpts = _.map(users, user => ({
			id: user?.userId,
			label: user?.fullName,
		}));
		return [{ id: 'all', label: 'All Members' }, ...userOpts];
	}
}
